import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PublicNav } from "@/components/PublicNav";

export const PublicHeader = ({ testId }) => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-20 flex items-center justify-between gap-3 px-5 md:px-14 py-5 bg-canvas/80 backdrop-blur-xl border-b border-line/60" data-testid="public-header">
      <Link to={user ? "/worlds" : "/"} className="font-display text-2xl text-amber-100" data-testid={testId}>Lore<span className="text-amber-500">ly</span></Link>
      <PublicNav />
    </header>
  );
};
